import { sprintf } from 'sprintf-js';

import type { ApiAddress } from 'api/types/ApiAddress';
import type { ApiRemoteOptions } from 'api/types/ApiRemoteOptions';
import { getCityStateString } from 'utils/address/getCityStateString';
import { getCountryName, getUsStateName } from 'utils/internationalization';

type Args = {
  listingType: 'JOB' | 'INTERNSHIP' | 'VOLOP' | 'EVENT';
  remoteOptions: ApiRemoteOptions;
  address: ApiAddress;
};

export function getWorkLocationSentence({
  listingType,
  remoteOptions,
  address,
}: Args) {
  if (remoteOptions.remoteZone && listingType === 'EVENT') {
    return getText('Can attend remotely');
  }

  if (remoteOptions.remoteZone === 'WORLD') {
    if (listingType === 'VOLOP') {
      return getText(
        'Volunteer can be anywhere in {{strong}}the world{{/strong}}',
      );
    }

    return getText(
      'Work can be performed from anywhere in {{strong}}the world{{/strong}}',
    );
  }

  if (remoteOptions.remoteZone === 'COUNTRY') {
    if (listingType === 'VOLOP') {
      return sprintf(
        getText('Volunteer must be in {{strong}}%(location)s{{/strong}}'),
        {
          location: getCountryName(remoteOptions.remoteCountry!),
        },
      );
    }

    return sprintf(
      getText(
        'Work can be performed from anywhere in {{strong}}%(location)s{{/strong}}',
      ),
      {
        location: getCountryName(remoteOptions.remoteCountry!),
      },
    );
  }

  if (remoteOptions.remoteZone === 'STATE') {
    if (listingType === 'VOLOP') {
      return sprintf(
        getText(
          'Volunteer must be in {{strong}}%(state)s, %(country)s{{/strong}}',
        ),
        {
          state: getUsStateName(remoteOptions.remoteState!),
          country: remoteOptions.remoteCountry!,
        },
      );
    }

    return sprintf(
      getText(
        'Work must be performed in {{strong}}%(state)s, %(country)s{{/strong}}',
      ),
      {
        state: getUsStateName(remoteOptions.remoteState || ''),
        country: remoteOptions.remoteCountry || '',
      },
    );
  }

  if (remoteOptions.remoteZone === 'CITY') {
    if (listingType === 'VOLOP') {
      return sprintf(
        getText(
          'Volunteer must be in or near {{strong}}%(location)s{{/strong}}',
        ),
        {
          location: getCityStateString(address),
        },
      );
    }

    return sprintf(
      getText(
        'Work must be performed in or near {{strong}}%(location)s{{/strong}}',
      ),
      {
        location: getCityStateString(address),
      },
    );
  }
}
